export default "__VITE_ASSET__CEkO4fQp__"